var _style, _g, _path, _path2, _path3, _defs, _g2, _line, _line2, _line3, _path4, _g3, _path5, _path6, _path7, _circle, _circle2, _path8, _path9, _defs2, _circle3, _circle4, _circle5, _circle6, _g4, _path10, _path11, _path12, _path13, _path14, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _path15, _path16, _path17, _path18, _path19, _path20, _defs3, _circle7, _circle8, _circle9, _defs4, _circle10, _circle11, _defs5, _defs6, _path21, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBaloonNoBg = function SvgBaloonNoBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 900",
    style: {
      enableBackground: "new 0 0 1440 900"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#081249;stroke-width:1.9702;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#081249;stroke-width:1.9702;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:10.0575,10.0575;}\n\t.st2{fill:#081249;}\n\t.st3{fill:#F83903;}\n\t.st4{clip-path:url(#SVGID_00000055682310848783434210000006563897144296648095_);fill:#FFFFFF;}\n\t.st5{fill:#F83D11;}\n\t.st6{fill:none;stroke:#081249;stroke-width:3.9705;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#081249;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#E41688;}\n\t.st9{fill:#EFEFEF;}\n\t.st10{fill:none;stroke:#081249;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:none;stroke:#081249;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st13{clip-path:url(#SVGID_00000176036345407116846680000002248880581499788192_);}\n\t.st14{clip-path:url(#SVGID_00000096769135502749278330000016721405635340115584_);fill:#F83903;}\n\t.st15{clip-path:url(#SVGID_00000096769135502749278330000016721405635340115584_);}\n\t.st16{fill:none;stroke:#081249;stroke-width:2.7611;stroke-miterlimit:10;}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000148653450120008852170000016890196906909893544_);fill:none;stroke:#081249;stroke-width:2.7611;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1189.73,309.72c0.01,1.68,0.02,3.35,0.01,5.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1189.55,324.81c-1.2,33.55-8.62,65.42-39.17,80.14c-91.14,43.9-62.02-70.44-20.25-62.61 c41.77,7.83,67.09,126.53-11.39,130.45c-69.54,3.47-288.6-177.41-468.35-114.79c-176.27,61.4-138.12,283.77-303.7,280.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.67,637.86c-1.65-0.08-3.33-0.18-5.02-0.31"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1118.89,90.08h-3.78c-3.19-4.83-8.66-8.02-14.89-8.02c-3.06,0-5.95,0.77-8.47,2.14 c-2.12-7.48-8.99-12.96-17.15-12.96c-6.11,0-11.49,3.07-14.71,7.75c-2.97-2.22-6.65-3.53-10.65-3.53c-8.76,0-16.04,6.32-17.54,14.64 c-9.56,0.38-17.19,8.24-17.19,17.89v0c0,9.89,8.02,17.91,17.91,17.91h86.45c9.89,0,17.91-8.02,17.91-17.91v0 C1136.8,98.1,1128.78,90.08,1118.89,90.08z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1358.62,273.99h-3.79c-3.2-4.85-8.69-8.05-14.93-8.05c-3.07,0-5.97,0.78-8.49,2.14c-2.12-7.5-9.02-13-17.2-13 c-6.12,0-11.53,3.08-14.75,7.78c-2.98-2.22-6.67-3.54-10.68-3.54c-8.78,0-16.08,6.34-17.59,14.69 c-9.59,0.38-17.24,8.26-17.24,17.94v0c0,9.92,8.04,17.96,17.96,17.96h86.71c9.92,0,17.96-8.04,17.96-17.96v0 C1376.58,282.03,1368.54,273.99,1358.62,273.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1320.26,294.78c1.58-4.82,6.11-8.3,11.45-8.3c1.75,0,3.41,0.38,4.91,1.05c4.4-9.23,13.81-15.61,24.71-15.61 c13.03,0,23.93,9.11,26.69,21.31c8.06,2.28,13.98,9.68,13.98,18.48v0c0,10.61-8.6,19.2-19.2,19.2h-53.47 c-10.61,0-19.2-8.6-19.2-19.2v0C1310.12,304.38,1314.22,298.02,1320.26,294.78z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1320.26,294.78c1.58-4.82,6.11-8.3,11.45-8.3c1.75,0,3.41,0.38,4.91,1.05 c4.4-9.23,13.81-15.61,24.71-15.61c13.03,0,23.93,9.11,26.69,21.31c8.06,2.28,13.98,9.68,13.98,18.48v0 c0,10.61-8.6,19.2-19.2,19.2h-53.47c-10.61,0-19.2-8.6-19.2-19.2v0C1310.12,304.38,1314.22,298.02,1320.26,294.78z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027592972134244584140000001010400455321667975_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027592972134244584140000001010400455321667975_)",
      fill: "#FFFFFF"
    },
    d: "M1358.62,273.99h-3.79 c-3.2-4.85-8.69-8.05-14.93-8.05c-3.07,0-5.97,0.78-8.49,2.14c-2.12-7.5-9.02-13-17.2-13c-6.12,0-11.53,3.08-14.75,7.78 c-2.98-2.22-6.67-3.54-10.68-3.54c-8.78,0-16.08,6.34-17.59,14.69c-9.59,0.38-17.24,8.26-17.24,17.94v0 c0,9.92,8.04,17.96,17.96,17.96h86.71c9.92,0,17.96-8.04,17.96-17.96v0C1376.58,282.03,1368.54,273.99,1358.62,273.99z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 218.35,
    cy: 358.87,
    r: 154.72
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 308.95,
    y1: 486.22,
    x2: 124.2,
    y2: 483.58
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 286.15,
    y1: 659.57,
    x2: 307.43,
    y2: 485.46
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 141.69,
    y1: 661.09,
    x2: 127.24,
    y2: 483.18
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M201.24,584.19L201.24,584.19c4.03-15.96-5.64-32.16-21.59-36.19l-29.71-7.51h0 c-4.03,15.96,5.64,32.16,21.59,36.19L201.24,584.19z"
  })), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M206.31,656.38c-0.87,18.73-2.15,37.4-5.59,55.88c-0.15,0.79-0.92,1.31-1.71,1.16s-1.31-0.92-1.16-1.71 c1.74-9.08,2.81-18.33,3.67-27.59c0.83-9.26,1.44-18.57,1.8-27.85C203.42,654.31,206.36,654.4,206.31,656.38L206.31,656.38z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M198.93,659.1c-0.35,8.19-0.9,16.47-1.61,24.63c-0.83,9.19-1.88,18.36-3.56,27.21 c-0.58,3.06,1.43,6,4.48,6.58c3.06,0.58,6-1.4,6.57-4.46c1.84-9.49,2.95-18.89,3.85-28.3c0.82-8.85,1.43-17.59,1.84-26.47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M253.4,623.56c-0.01-0.02,0.01,0.04,0.03,0.07l0.05,0.12l0.1,0.25l0.23,0.52c0.16,0.35,0.32,0.71,0.49,1.07 c0.34,0.72,0.69,1.44,1.06,2.15c0.74,1.42,1.53,2.83,2.36,4.17c1.67,2.69,3.55,5.21,5.55,7.22c1,1,2.03,1.87,3.04,2.54 c1.01,0.67,1.99,1.14,2.94,1.42c0.47,0.14,0.94,0.23,1.41,0.27c0.24,0.02,0.47,0.03,0.71,0.03c0.12,0.01,0.24-0.01,0.36-0.01 l0.09,0l0.05,0l0,0c0,0,0,0,0.01,0.01c0.03,0.01,0.22-0.02,0.52-0.18c0.29-0.16,0.67-0.44,1.07-0.8c0.8-0.73,1.64-1.78,2.44-2.94 c0.8-1.16,1.58-2.45,2.34-3.79c1.52-2.68,2.96-5.56,4.47-8.48c1.51-2.92,3.07-5.9,4.91-8.85c0.93-1.47,1.92-2.94,3.07-4.38 c1.15-1.43,2.44-2.85,4.05-4.13c2-1.59,5.11-1.11,6.96,1.07c1.8,2.12,1.73,5.08-0.13,6.7l-0.05,0.05 c-0.89,0.77-1.76,1.79-2.58,2.91c-0.82,1.13-1.6,2.38-2.34,3.69c-1.49,2.63-2.84,5.48-4.2,8.41c-1.36,2.93-2.71,5.95-4.26,9 c-0.78,1.53-1.62,3.07-2.58,4.61c-0.98,1.55-2.06,3.11-3.57,4.65c-0.76,0.77-1.63,1.53-2.72,2.23c-1.09,0.69-2.44,1.32-4.05,1.63 l-0.62,0.1l-0.15,0.02l-0.11,0.01l-0.23,0.02c-0.3,0.03-0.6,0.07-0.91,0.08c-0.61,0.04-1.23,0.04-1.85,0.02 c-1.25-0.05-2.51-0.23-3.75-0.52c-2.48-0.58-4.8-1.62-6.84-2.85c-2.05-1.24-3.86-2.66-5.49-4.16c-3.25-3-5.82-6.26-8.08-9.59 c-1.13-1.67-2.17-3.36-3.15-5.07c-0.49-0.86-0.96-1.73-1.42-2.61c-0.23-0.44-0.45-0.88-0.68-1.34l-0.33-0.69l-0.17-0.36 l-0.19-0.43c-1.47-3.48,0.06-7.17,3.42-8.23C248.02,618.12,251.93,620.08,253.4,623.56z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M253.48,623.74l0.1,0.25l0.23,0.52c0.16,0.35,0.32,0.71,0.49,1.07c0.34,0.72,0.69,1.44,1.06,2.15 c0.74,1.42,1.53,2.83,2.36,4.17c1.67,2.69,3.55,5.21,5.55,7.22c1,1,2.03,1.87,3.04,2.54c1.01,0.67,1.99,1.14,2.94,1.42 c0.47,0.14,0.94,0.23,1.41,0.27c0.24,0.02,0.47,0.03,0.71,0.03c0.12,0.01,0.24-0.01,0.36-0.01l0.09,0l0.05,0l0,0 c0,0,0,0,0.01,0.01c0.03,0.01,0.22-0.02,0.52-0.18c0.29-0.16,0.67-0.44,1.07-0.8c0.8-0.73,1.64-1.78,2.44-2.94 c0.8-1.16,1.58-2.45,2.34-3.79c1.52-2.68,2.96-5.56,4.47-8.48c1.51-2.92,3.07-5.9,4.91-8.85c0.93-1.47,1.92-2.94,3.07-4.38 c1.15-1.43,2.44-2.85,4.05-4.13c2-1.59,5.11-1.11,6.96,1.07c1.8,2.12,1.73,5.08-0.13,6.7l-0.05,0.05 c-0.89,0.77-1.76,1.79-2.58,2.91c-0.82,1.13-1.6,2.38-2.34,3.69c-1.49,2.63-2.84,5.48-4.2,8.41c-1.36,2.93-2.71,5.95-4.26,9 c-0.78,1.53-1.62,3.07-2.58,4.61c-0.98,1.55-2.06,3.11-3.57,4.65c-0.76,0.77-1.63,1.53-2.72,2.23c-1.09,0.69-2.44,1.32-4.05,1.63 l-0.62,0.1l-0.15,0.02l-0.11,0.01l-0.23,0.02c-0.3,0.03-0.6,0.07-0.91,0.08c-0.61,0.04-1.23,0.04-1.85,0.02 c-1.25-0.05-2.51-0.23-3.75-0.52c-2.48-0.58-4.8-1.62-6.84-2.85c-2.05-1.24-3.86-2.66-5.49-4.16c-3.25-3-5.82-6.26-8.08-9.59 c-1.13-1.67-2.17-3.36-3.15-5.07c-0.49-0.86-0.96-1.73-1.42-2.61c-0.23-0.44-0.45-0.88-0.68-1.34l-0.33-0.69l-0.17-0.36 l-0.19-0.43"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 219.16,
    cy: 623.74,
    r: 43.58
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 219.16,
    cy: 623.74,
    r: 43.58
  })), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.2,616.17l17.34,1.52c1.96,0.17,3,2.42,1.84,4.02c-2.1,2.89-5.84,6.34-11.48,5.74 c-5.58-0.59-8.63-4.5-10.2-7.62C219.81,618.05,221.23,616,223.2,616.17z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M225.72,628.38c0,0,5.26,4.92,11.94,0.91"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000045620676203177409150000009606443899018880944_",
    d: "M223.2,616.17l17.34,1.52c1.96,0.17,3,2.42,1.84,4.02 c-2.1,2.89-5.84,6.34-11.48,5.74c-5.58-0.59-8.63-4.5-10.2-7.62C219.81,618.05,221.23,616,223.2,616.17z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065046932077944724150000012421771379498527372_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045620676203177409150000009606443899018880944_",
    style: {
      overflow: "visible"
    }
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 241.35,
    cy: 611.2,
    r: 3.04
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 222.97,
    cy: 609.36,
    r: 3.04
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 212.75,
    cy: 613.89,
    r: 5.15
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 250.61,
    cy: 617.59,
    r: 5.15
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M235.01,660.2c1.68,18.68,2.94,37.34,2.03,56.12c-0.04,0.81-0.73,1.43-1.54,1.38 c-0.81-0.04-1.43-0.73-1.38-1.54c0.49-9.23,0.3-18.54-0.11-27.83c-0.43-9.29-1.09-18.6-1.99-27.84 C231.86,658.54,234.78,658.22,235.01,660.2L235.01,660.2z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M228.06,663.89c0.76,8.16,1.34,16.44,1.74,24.63c0.42,9.22,0.62,18.45,0.16,27.45 c-0.16,3.11,2.23,5.75,5.33,5.91c3.11,0.16,5.75-2.2,5.91-5.31c0.54-9.66,0.37-19.12-0.01-28.56c-0.39-8.88-0.96-17.63-1.77-26.48 "
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M157.34,757.65h110.87c5.91,0,10.9-4.38,11.67-10.24l9.08-69.21c0.92-7.05-4.56-13.3-11.67-13.3H148.26 c-7.11,0-12.6,6.25-11.67,13.3l9.08,69.21C146.43,753.27,151.43,757.65,157.34,757.65z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.34,757.65h110.87c5.91,0,10.9-4.38,11.67-10.24l9.08-69.21c0.92-7.05-4.56-13.3-11.67-13.3H148.26 c-7.11,0-12.6,6.25-11.67,13.3l9.08,69.21C146.43,753.27,151.43,757.65,157.34,757.65z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.55,679.42h151.39c2.71,0,4.9-2.19,4.9-4.9v-8.45c0-2.71-2.19-4.9-4.9-4.9H137.55 c-2.71,0-4.9,2.19-4.9,4.9v8.45C132.65,677.23,134.84,679.42,137.55,679.42z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M137.55,679.42h151.39c2.71,0,4.9-2.19,4.9-4.9v-8.45c0-2.71-2.19-4.9-4.9-4.9H137.55 c-2.71,0-4.9,2.19-4.9,4.9v8.45C132.65,677.23,134.84,679.42,137.55,679.42z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 275.12,
    y1: 693.2,
    x2: 243.14,
    y2: 693.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 264.56,
    y1: 699.2,
    x2: 264.56,
    y2: 712.62
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 255.14,
    y1: 698.91,
    x2: 255.14,
    y2: 712.91
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 279.98,
    y1: 727.18,
    x2: 261.13,
    y2: 727.18
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 248,
    y1: 706.91,
    x2: 202.02,
    y2: 706.91
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 236.57,
    y1: 712.05,
    x2: 236.57,
    y2: 729.47
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 223.72,
    y1: 711.19,
    x2: 223.72,
    y2: 722.9
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 251.99,
    y1: 734.32,
    x2: 216.01,
    y2: 734.32
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 238.57,
    y1: 742.03,
    x2: 210.02,
    y2: 742.03
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 202.88,
    y1: 690.92,
    x2: 176.89,
    y2: 690.92
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 193.46,
    y1: 698.63,
    x2: 193.46,
    y2: 716.9
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 182.6,
    y1: 694.92,
    x2: 182.6,
    y2: 706.62
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 164.33,
    y1: 690.63,
    x2: 141.77,
    y2: 690.63
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 169.18,
    y1: 710.62,
    x2: 150.91,
    y2: 710.62
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 203.74,
    y1: 721.19,
    x2: 166.33,
    y2: 721.19
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 188.89,
    y1: 727.18,
    x2: 188.89,
    y2: 742.32
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 176.89,
    y1: 725.47,
    x2: 176.89,
    y2: 744.89
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M228.08,658.73c-2-0.48-3.9-0.66-5.73-0.73c-1.83-0.07-3.6,0-5.33,0.11c-3.45,0.23-6.75,0.68-9.98,1.14 c-3.22,0.46-6.38,0.94-9.42,1.27c-1.52,0.16-3.01,0.28-4.42,0.32c-1.4,0.04-2.75-0.01-3.81-0.2c-0.53-0.09-0.98-0.22-1.28-0.34 c-0.31-0.13-0.44-0.25-0.46-0.28c0-0.01,0-0.01,0-0.01l0,0l-0.03-0.03l-0.06-0.06c-0.08-0.09-0.16-0.16-0.23-0.26 c-0.15-0.17-0.28-0.35-0.41-0.53c-0.25-0.36-0.47-0.75-0.64-1.16c-0.36-0.82-0.58-1.78-0.67-2.86c-0.09-1.08-0.03-2.28,0.15-3.52 c0.36-2.5,1.21-5.18,2.31-7.8c0.55-1.31,1.18-2.62,1.85-3.9c0.34-0.64,0.69-1.27,1.05-1.89c0.18-0.31,0.36-0.62,0.55-0.91 l0.27-0.44l0.13-0.21l0.06-0.09c0.01-0.02,0.03-0.04,0.03-0.05c-1.88-3.74-5.43-6.72-9.74-7.64c-0.27,0.28-0.51,0.59-0.73,0.93 l-0.22,0.36l-0.18,0.31l-0.34,0.6c-0.22,0.4-0.43,0.8-0.64,1.19c-0.42,0.79-0.81,1.59-1.19,2.4c-0.76,1.61-1.45,3.25-2.08,4.94 c-1.24,3.38-2.25,6.95-2.64,10.86c-0.19,1.96-0.21,4.01,0.07,6.14c0.28,2.12,0.88,4.33,1.93,6.42c0.52,1.04,1.15,2.04,1.88,2.96 c0.36,0.46,0.74,0.9,1.15,1.32c0.2,0.22,0.41,0.41,0.61,0.61l0.16,0.15l0.08,0.07l0.11,0.1l0.45,0.39c1.23,1,2.55,1.64,3.76,2.05 c1.21,0.41,2.35,0.64,3.42,0.78c2.14,0.27,4.03,0.22,5.85,0.11c1.81-0.12,3.54-0.33,5.22-0.58c3.36-0.5,6.56-1.12,9.71-1.69 c3.14-0.57,6.22-1.11,9.2-1.42c1.49-0.15,2.95-0.26,4.34-0.26c1.39-0.01,2.72,0.08,3.87,0.31l0.07,0.01 c2.41,0.48,4.79-1.03,5.37-3.45C232.08,661.82,230.56,659.33,228.08,658.73z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M191.92,636.44l-0.13,0.21l-0.27,0.44c-0.18,0.3-0.37,0.6-0.55,0.91c-0.36,0.62-0.71,1.25-1.05,1.89 c-0.68,1.28-1.3,2.59-1.85,3.9c-1.11,2.62-1.95,5.3-2.31,7.8c-0.18,1.25-0.23,2.44-0.15,3.52c0.09,1.08,0.31,2.04,0.67,2.86 c0.18,0.41,0.39,0.8,0.64,1.16c0.13,0.18,0.26,0.36,0.41,0.53c0.07,0.09,0.15,0.17,0.23,0.26l0.06,0.06l0.03,0.03l0,0 c0,0,0,0,0,0.01c0.01,0.03,0.15,0.15,0.46,0.28c0.31,0.13,0.76,0.25,1.28,0.34c1.06,0.19,2.41,0.24,3.81,0.2 c1.41-0.04,2.9-0.16,4.42-0.32c3.04-0.33,6.2-0.81,9.42-1.27c3.23-0.46,6.53-0.91,9.98-1.14c1.73-0.11,3.49-0.17,5.33-0.11 c1.83,0.07,3.73,0.25,5.73,0.73c2.47,0.6,4,3.08,3.4,5.56c-0.58,2.41-2.96,3.92-5.37,3.45l-0.07-0.01 c-1.15-0.23-2.48-0.32-3.87-0.31c-1.39,0-2.86,0.11-4.34,0.26c-2.98,0.32-6.06,0.85-9.2,1.42c-3.15,0.57-6.35,1.2-9.71,1.69 c-1.68,0.25-3.41,0.46-5.22,0.58c-1.82,0.11-3.71,0.16-5.85-0.11c-1.07-0.14-2.2-0.36-3.42-0.78c-1.21-0.42-2.53-1.06-3.76-2.05 l-0.45-0.39l-0.11-0.1l-0.08-0.07l-0.16-0.15c-0.21-0.2-0.42-0.4-0.61-0.61c-0.4-0.42-0.78-0.86-1.15-1.32 c-0.72-0.92-1.35-1.92-1.88-2.96c-1.05-2.09-1.65-4.3-1.93-6.42c-0.28-2.13-0.25-4.18-0.07-6.14c0.39-3.92,1.4-7.48,2.64-10.86 c0.63-1.69,1.32-3.33,2.08-4.94c0.38-0.8,0.77-1.6,1.19-2.4c0.21-0.4,0.42-0.79,0.64-1.19l0.34-0.6l0.18-0.31l0.22-0.36"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1370.07,130.72l3.66,12.27c0.19,0.65,0.7,1.16,1.34,1.37l12.19,3.94c1.62,0.52,1.94,2.68,0.54,3.65 l-10.54,7.28c-0.56,0.39-0.89,1.02-0.89,1.7l0.02,12.81c0,1.71-1.95,2.68-3.31,1.64l-10.18-7.77c-0.54-0.41-1.25-0.53-1.89-0.32 l-12.17,3.98c-1.62,0.53-3.15-1.03-2.58-2.64l4.25-12.08c0.22-0.64,0.12-1.35-0.28-1.9l-7.55-10.35c-1.01-1.38,0.01-3.31,1.71-3.27 l12.8,0.31c0.68,0.02,1.32-0.3,1.72-0.85l7.51-10.37C1367.43,128.71,1369.58,129.08,1370.07,130.72z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1085.59,221.74l8.96,9.15c0.47,0.48,1.16,0.7,1.82,0.59l12.62-2.19c1.68-0.29,2.97,1.47,2.18,2.98l-5.94,11.35 c-0.31,0.6-0.31,1.32,0,1.92l5.98,11.32c0.8,1.51-0.48,3.28-2.16,2.99l-12.63-2.14c-0.67-0.11-1.35,0.11-1.82,0.6l-8.92,9.19 c-1.19,1.23-3.27,0.56-3.52-1.13l-1.87-12.67c-0.1-0.67-0.52-1.25-1.13-1.55l-11.5-5.64c-1.53-0.75-1.54-2.93-0.01-3.69l11.47-5.69 c0.61-0.3,1.03-0.88,1.12-1.55l1.81-12.68C1082.32,221.2,1084.4,220.52,1085.59,221.74z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1305.38,368.9l0.93,6.41c0.05,0.34,0.26,0.63,0.57,0.78l5.81,2.87c0.77,0.38,0.77,1.49,0,1.87l-5.81,2.87 c-0.31,0.15-0.52,0.45-0.57,0.78l-0.93,6.41c-0.12,0.85-1.17,1.2-1.78,0.58l-4.52-4.64c-0.24-0.25-0.58-0.36-0.92-0.3l-6.39,1.1 c-0.85,0.15-1.5-0.75-1.1-1.51l3.01-5.74c0.16-0.3,0.16-0.67,0-0.97l-3.02-5.73c-0.4-0.76,0.25-1.66,1.1-1.51l6.39,1.09 c0.34,0.06,0.68-0.05,0.92-0.3l4.52-4.64C1304.21,367.7,1305.26,368.05,1305.38,368.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1188.06,71.62l3.23,5.62c0.17,0.3,0.48,0.49,0.82,0.52l6.46,0.53c0.86,0.07,1.27,1.1,0.69,1.74l-4.35,4.81 c-0.23,0.25-0.32,0.61-0.24,0.94l1.5,6.3c0.2,0.84-0.65,1.54-1.44,1.19l-5.91-2.65c-0.31-0.14-0.67-0.12-0.97,0.06l-5.53,3.37 c-0.74,0.45-1.67-0.14-1.58-1l0.69-6.44c0.04-0.34-0.1-0.68-0.36-0.9l-4.92-4.22c-0.66-0.56-0.38-1.63,0.46-1.81l6.34-1.33 c0.34-0.07,0.61-0.3,0.75-0.62l2.5-5.98C1186.53,70.94,1187.63,70.87,1188.06,71.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000046311926980185743860000001535763516750675611_",
    cx: 1218.02,
    cy: 198.4,
    r: 53.11
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046311926980185743860000001535763516750675611_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070828614141803842840000004034408106538266758_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046311926980185743860000001535763516750675611_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070828614141803842840000004034408106538266758_)"
    }
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 1189.59,
    cy: 200.05,
    r: 9.63
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 1242.46,
    cy: 235.53,
    r: 19.27
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 1236.35,
    cy: 176.32,
    r: 16.45
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000102543594442314988590000009023153844555420834_",
    cx: 1218.02,
    cy: 198.4,
    r: 53.11
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002346485923512550990000014194199303478727819_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102543594442314988590000009023153844555420834_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000002346485923512550990000014194199303478727819_)",
      fill: "#F83903"
    },
    cx: 1202.98,
    cy: 183.13,
    r: 53.58
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000002346485923512550990000014194199303478727819_)"
    }
  }, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 1233.8,
    cy: 186.53,
    r: 16.45
  })))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 1218.02,
    cy: 198.4,
    r: 53.11
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000169546331124315591790000012818257021081477815_",
    cx: 1218.02,
    cy: 198.4,
    r: 53.11
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057141199207161079960000005383210506222204331_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169546331124315591790000012818257021081477815_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000081621348043185163610000011639317680125913491_",
    cx: 1218.02,
    cy: 198.4,
    r: 53.11
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134247353029306662950000009884271179749415095_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081621348043185163610000011639317680125913491_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000134247353029306662950000009884271179749415095_)",
      fill: "none",
      stroke: "#081249",
      strokeWidth: 2.7611,
      strokeMiterlimit: 10
    },
    cx: 1170.93,
    cy: 203.35,
    r: 12.93
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M229.2,621.73c-2.45-0.26-4.73,0.28-6.39,1.33c1.78,2.12,4.37,3.99,8.08,4.38c2.19,0.23,4.09-0.15,5.73-0.87 C235.73,624.12,232.83,622.11,229.2,621.73z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBaloonNoBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "baloon_no_bg.2dabb3c.svg";